import Settings from 'core/settings'

export const maxOwnerWorkflowExceeded = ({ workflows: { collection: { length } } }) => (
  length >= Settings.max_workflow_limit
)
